<template>
  <div class="header__notification header__drodown-parent">
    <a href="#">
      <i class="fa fa-bell"></i>
      <span v-if="unread_notifications_count && unread_notifications_count>0">
        <i>{{unread_notifications_count}}</i>
      </span>
    </a>
    <div class="header__dropdown ps-block--notifications">
      <div class="ps-block__header">
        <i class="fa fa-sliders"></i>
      </div>
      <div class="ps-block__content">
        <div
          v-for="(notification,index) in notifications"
          :key="index"
          class="ps-block--notification"
        >
          <div class="ps-block__thumbnail">
            <img :src="notification.data.image" alt />
          </div>
          <div class="ps-block__content">
            <a :href="notification.data.url">{{notification.data.title}}</a>
            <p>{{notification.data.message}}</p>
            <small>
              <local-time :time="notification.created_at"></local-time>
            </small>
            <a class="ps-btn ps-btn--close" @click.prevent="readNotification(notification)"></a>
          </div>
        </div>
      </div>
      <div class="ps-block__footer text-center">
        <a href="/dashboard/notifications">
          <span class="ps-icon--dots">
            <i></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LocalTime from "./../../../LocalTime";

export default {
  components: {
    LocalTime
  },
  props: ["user"],
  data() {
    return {
      User: null,
      notifications: [],
      unread_notifications_count: 0
    };
  },
  mounted() {
    let self = this;
    this.getLastUnreadNotifications();
    this.getUnreadNotificationsCount();
    this.User = JSON.parse(this.user);
    Echo.private("App.User." + this.User.id).notification(notification => {
      self.getLastUnreadNotifications();
      self.getUnreadNotificationsCount();
    });
  },

  methods: {
    readNotification: function(notification) {
      let self = this;
      axios({
        method: "get",
        url:
          "/api/v1/notification/" +
          notification.id +
          "/mark-as-read-notification/?api_token=" +
          window.api_token
      })
        .then(function(response) {
          self.getLastUnreadNotifications();
          self.getUnreadNotificationsCount();
        })
        .catch(function(err) {
          let errors = err.response.data.errors;
        });
    },
    getLastUnreadNotifications: function() {
      let self = this;
      axios({
        method: "get",
        url:
          "/api/v1/notification/get-latest-unread-notifications/" +
          window.user_id +
          "/5?api_token=" +
          window.api_token
      })
        .then(function(response) {
          //console.log(response.data);
          self.notifications = response.data.data;
          self.unread_notifications_count =
            response.data.unread_notifications_count;
        })
        .catch(function(err) {
          //let errors = err.response.data.errors;
          //console.log(errors);
        });
    },
    getUnreadNotificationsCount: function() {
      let self = this;
      axios({
        method: "get",
        url:
          "/api/v1/notification/get-number-of-unread-notification/" +
          window.user_id +
          "?api_token=" +
          window.api_token
      })
        .then(function(response) {
          self.unread_notifications_count = response.data.data;
        })
        .catch(function(err) {});
    }
  }
};
</script>
